var generateStyle = function generateStyle(componentTheme) {
  return {
    alertWrapper: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      marginTop: componentTheme.alertWrapperMargin
    },
    alertWidth: {
      flexGrow: 1,
      maxWidth: '33rem,'
    },
    wrapper: {
      padding: 'none',
      margin: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    info: {
      alignSelf: 'center',
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'center'
    },
    scoreStats: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'flex-start',
      flex: '1 1 auto'
    },
    score: {
      display: 'flex',
      alignItems: 'center',
      flex: '1 1 auto',
      margin: componentTheme.scoreMargin,
      height: '150px',
      width: '150px',
      /*
        progress modal sets a -1 z-index on its content
        and this raises it above the app background
      */
      zIndex: componentTheme.scoreZIndex
    },
    scorePercentage: {
      fontSize: componentTheme.scorePercentageFontSize,
      fontWeight: componentTheme.scorePercentageFontWeight
    },
    infoWrapper: {
      flex: '1 1 auto',
      margin: componentTheme.infoWrapperMargin,
      paddingLeft: componentTheme.inforWrapperPadding
    }
  };
};
export default generateStyle;